import { Component } from '@angular/core';
import {NgbActiveModal} from "@ng-bootstrap/ng-bootstrap";
import {getElternKeyPrettyName, IEltern} from "../../../models/IEltern.interface";
import {ElternService} from "../../../service/eltern.service";
import {ToastrService} from "ngx-toastr";
import {SessionService} from "../../../service/session.service";
import {Rolle} from "../../../models/enums";

@Component({
  selector: 'app-create-eltern',
  templateUrl: './create-eltern.component.html',
  styleUrls: ['./create-eltern.component.scss']
})
export class CreateElternComponent {

  public eltern: IEltern = {
    id: -1,
    vorname: '',
    nachname: '',
    strasse: '',
    hausnummer: '',
    plz: 0,
    ort: '',
    zusatz: '',
    mail: '',
    telefon: '',
    mobile: '',
    passworthash: '',
    lastPasswordChange: Date.now(),
    kontoinhaber: '',
    iban: '',
    bic: '',
    bank: '',
    rolle: Rolle.WAIT,
    newsletter: false,
    kinder: [],
    created: Date.now(),
    edited: Date.now(),
    tstActivate: null
  };
  private findAndCloseTimeout: any;

  constructor(
      public activeModal: NgbActiveModal,
      public elternService: ElternService,
      private toast: ToastrService,
      public sessionService: SessionService,
  ) {
    this.fields1.forEach(v => {
      if(!v.label) {
        return v.label = getElternKeyPrettyName(v.key as keyof IEltern);
      }
    });
  }

  public readonly fields1: Array<{
    key: keyof IEltern,
    type: "text" | "phone" | "mail" | "number" | "decimal" | "password" | "date" | "dateTime" | "iban" | "textarea"
    placeholder: string,
    pflichtfeld: boolean
    label?: string,
    noData?: string
  }> = [
    {key: 'vorname', type: 'text', placeholder: 'Max', pflichtfeld: true},
    {key: 'nachname', type: 'text', placeholder: 'Mustermann', pflichtfeld: true},
    {key: 'mail', type: 'mail', placeholder: 'max@mustermann.de', pflichtfeld: false, noData: "---"},
    {key: 'strasse', type: 'text', placeholder: 'Haupstraße', pflichtfeld: true},
    {key: 'hausnummer', type: 'text', placeholder: '1a', pflichtfeld: true},
    {key: 'plz', type: 'number', placeholder: '11111', pflichtfeld: true},
    {key: 'ort', type: 'text', placeholder: 'Musterstadt', pflichtfeld: true},
    {key: 'zusatz', type: 'text', placeholder: 'Im ersten Stock', pflichtfeld: false},

    {key: 'telefon', type: 'phone', placeholder: '0461 930 644 0', pflichtfeld: false},
    {key: 'mobile', type: 'phone', placeholder: '0151 ....', pflichtfeld: false},
    {key: 'kontoinhaber', type: 'text', placeholder: 'kontoinhaber', pflichtfeld: false, noData: "---"},
    {key: 'iban', type: 'iban', placeholder: 'iban', pflichtfeld: false, noData: "---"},
    {key: 'bic', type: 'text', placeholder: 'bic', pflichtfeld: false, noData: "---"},
    {key: 'bank', type: 'text', placeholder: 'bank', pflichtfeld: false, noData: "---"},
  ];

  public async save() {
    const validationResult = this.validate();
    if (validationResult === 'OK') {
      try {
        this.toast.success("Eltern werden erstellt, bitte warte einen Moment.", "Erfolgreich");
        const createResult = await this.elternService.create(this.eltern);
        this.toast.success(createResult.msg, 'Erfolgreich angelegt');
        this.findAndClose(createResult.id!);
      } catch (msg) {
        this.toast.error(msg, 'Fehler');
        clearTimeout(this.findAndCloseTimeout);
      }
    }else {
      this.toast.warning(validationResult, 'Ungültige Daten');
    }
  }

  findAndClose(id: number, retry = 600) {
    this.findAndCloseTimeout = setTimeout(() => {
      const e = this.elternService.getById(id);
      if(e) {
        this.activeModal.close(e);
      } else {
        this.findAndClose(id, retry - 1);
      }
    }, 100);
  }

  private validate(): string {
    if (this.eltern.mail && this.eltern.mail.indexOf(" ") !== -1) {
      return 'E-Mail darf kein Leerzeichen enthalten.'
    }
    if (!this.eltern.vorname) {
      return 'Es muss ein Vorname eingegeben werden.';
    }
    return 'OK';
  }

}
